import React from 'react';
import './DMCA.css';

const DMCA: React.FC = () => {
  return (
    <div className="dmca-container">
      <div className="dmca-content">
        <header className="dmca-header">
          <div className="dmca-icon">
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M3 21H21V19H3V21ZM5 17H19V15H5V17ZM7 13H17V11H7V13ZM9 9H15V7H9V9ZM11 5H13V3H11V5Z" fill="#c95549"/>
              <path d="M12 2L13.09 8.26L22 9L13.09 9.74L12 16L10.91 9.74L2 9L10.91 8.26L12 2Z" fill="#c95549"/>
            </svg>
          </div>
          <h1 className="dmca-title">DMCA</h1>
          <p className="dmca-subtitle">Digital Millennium Copyright Act Notice</p>
        </header>

        <div className="dmca-body">
          <section className="dmca-intro">
            <p>
              <strong>SoundLegal, Inc. ("SoundLegal")</strong> respects intellectual property and complies with the Digital Millennium Copyright Act (<strong>DMCA</strong>, 17 U.S.C. §512). This page explains how to submit <strong>takedown notices</strong> and <strong>counter-notices</strong>, identifies our <strong>Designated Agent</strong>, and describes our <strong>repeat-infringer</strong> policy.
            </p>
          </section>

          <section className="dmca-section">
            <h2>Designated Agent (DMCA §512(c)(2))</h2>
            <ul>
              <li><strong>Email:</strong> <a href="mailto:info@soundlegal.ai">info@soundlegal.ai</a></li>
              <li><strong>Electronic submission:</strong> Send your notice via email in PDF or plaintext.</li>
              <li><strong>Postal service:</strong> Our Designated Agent's mailing address is publicly listed in the <strong>U.S. Copyright Office Directory</strong> for SoundLegal, Inc. and will be provided upon request to <a href="mailto:info@soundlegal.ai">info@soundlegal.ai</a>.</li>
            </ul>
            <blockquote className="dmca-note">
              We maintain the Designated Agent registration with the U.S. Copyright Office and promptly update it when details change.
            </blockquote>
          </section>

          <section className="dmca-section">
            <h2>How to Send a Valid DMCA Takedown Notice (DMCA §512(c)(3))</h2>
            <p>Your notice <strong>must</strong> include, verbatim or in substance:</p>
            <ol>
              <li><strong>Work identified:</strong> The copyrighted work you claim is infringed (or a representative list).</li>
              <li><strong>Location identified:</strong> The material to be removed or disabled, with sufficient detail to locate it (e.g., URL, filename, unique ID, date/time).</li>
              <li><strong>Contact info:</strong> Your full legal name, postal address, phone, and email.</li>
              <li><strong>Good-faith statement:</strong> "I have a good-faith belief that the use of the material is not authorized by the copyright owner, its agent, or the law."</li>
              <li><strong>Authority & accuracy (penalty of perjury):</strong> "The information in this notice is accurate, and I am authorized to act on behalf of the owner of an exclusive right that is allegedly infringed."</li>
              <li><strong>Signature:</strong> Physical or electronic (typing your full legal name suffices).</li>
            </ol>
            <p><strong>Incomplete notices may be rejected</strong>. Upon receipt of a facially valid notice, we will <strong>expeditiously</strong> remove/disable access and notify the affected user (if applicable).</p>
            <blockquote className="dmca-warning">
              <strong>Misuse warning (DMCA §512(f)):</strong> Knowingly submitting false claims may create liability for damages, costs, and attorneys' fees.
            </blockquote>
          </section>

          <section className="dmca-section">
            <h2>Counter-Notification (DMCA §512(g))</h2>
            <p>If your material was removed due to a notice and you believe it was a <strong>mistake</strong> or <strong>misidentification</strong>:</p>
            <ol>
              <li>Identify the removed material and its prior location (URL/ID).</li>
              <li>State <strong>under penalty of perjury</strong> your good-faith belief the material was removed/disabled due to mistake or misidentification.</li>
              <li>Provide your name, address, phone, and state that you <strong>consent to the jurisdiction</strong> of the U.S. federal district court in your judicial district (or where SoundLegal is located if outside the U.S.), and that you will accept service of process from the original complainant.</li>
              <li>Sign (physical or electronic).</li>
            </ol>
            <p>Send to <a href="mailto:info@soundlegal.ai">info@soundlegal.ai</a> (PDF or plaintext). We will forward your counter-notice to the complainant. If we do <strong>not</strong> receive notice of a court action within <strong>10 business days</strong>, we may restore the material.</p>
          </section>

          <section className="dmca-section">
            <h2>Repeat-Infringer Policy & Standard Technical Measures</h2>
            <ul>
              <li>We <strong>terminate or suspend</strong> accounts of repeat infringers in appropriate circumstances.</li>
              <li>We accommodate and do not interfere with <strong>standard technical measures</strong> used by copyright owners for identification/protection of works.</li>
            </ul>
          </section>

          <section className="dmca-section">
            <h2>Subpoenas and Preservation</h2>
            <p>Upon receipt of a valid subpoena or court order, we may disclose limited subscriber information as required by law. We preserve records consistent with legal obligations.</p>
          </section>

          <hr className="dmca-divider" />

          <section className="dmca-section dmca-contact">
            <h2>Contact Information</h2>
            <div className="contact-grid">
              <div className="contact-item">
                <h3>DMCA Designated Agent</h3>
                <p><strong>Email:</strong> <a href="mailto:info@soundlegal.ai">info@soundlegal.ai</a></p>
                <p><strong>Response Time:</strong> Within 24-48 hours</p>
              </div>
              <div className="contact-item">
                <h3>General Legal Inquiries</h3>
                <p><strong>Email:</strong> <a href="mailto:info@soundlegal.ai">info@soundlegal.ai</a></p>
                <p><strong>Subject Line:</strong> "DMCA Notice" or "DMCA Counter-Notice"</p>
              </div>
            </div>
            <div className="dmca-footer-note">
              <p><strong>Important:</strong> This page is for DMCA-related notices only. For other legal matters, please contact us through our general legal channels.</p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default DMCA;
